/* eslint-disable */

import $ from 'jquery';
import loadingLayer from '../../util/loadingLayer';
import formMessages from '../../util/formMessages';
import createForm from '../../util/createForm';
import stateAndCountry from '../../util/stateAndCountry';

export default {
	init() {
		formMessages().useCaptcha();
		const $form = $('#donation-form');
		const url = $form.attr('action-ajax') || $form.attr('action');
		const method = $form.attr('method');
		var data = {};

		$('input[type="radio"][name="amount"]', $form).on('click', function () {
			if ($(this).val() == '') {
				$('.donate-amount input.custom-control-input', $form).addClass('d-none');
				const $other = $('#other_amount', $form);

				const $label = $other.find('.form-group label');
				$label.removeClass('text-blue');
				$label.addClass('text-light');

				$other.removeClass('is-valid')
				$other.removeClass('is-invalid');
				$other.css('display', 'block');
			} else {
				$('.donate-amount input.custom-control-input', $form).removeClass('d-none');
				$('#other_amount', $form).css('display', 'none');
			}
		});

		stateAndCountry($form);
		formMessages($form).validate();

		$form.on('submit', function (event) {
			event.stopImmediatePropagation();
			event.preventDefault();

			loadingLayer.showLoading();
			const $form = $(this);
			formMessages($form).init();

			const formData = $form.find("select:visible,input[type=hidden],:input:visible,textarea:visible").serializeArray();
			for (var i in formData) {
				data[formData[i].name] = formData[i].value;

				$('#' + formData[i].name, $form).removeClass('is-invalid');
				$('#' + formData[i].name + ' ~ .invalid-feedback', $form).text('');
			}

			$.ajax({
				url,
				method: 'post',
				data: {
					...data,
					nonce: window.meta_object.nonce,
					captcha_token: window.meta_object.captcha_token,
					action: 'donate-access-code',
				},
				dataType: 'json'
			}).always(() => {
				formMessages().reloadCaptcha();
			}).fail(() => {
				loadingLayer.hideLoading();
			}).done((validateData) => {
				if (validateData && !validateData.success) {
					formMessages($form, validateData).run();
					loadingLayer.hideLoading();
					return;
				}
				if (validateData.data.ecrypt_btn) {
					$("#eway-ecrypt").html(validateData.data.ecrypt_btn);
					loadingLayer.hideLoading();

					setTimeout(function () {
						$("#btn-eway-payment").click();
						loadingLayer.hideLoading();
					}, 500);
				}
			});
		});

		$("#btn-eway-payment").on("click", function () {
			eCrypt.showModalPayment(eWAYConfig, function (result, transactionID, errors) {
				if (result == "Complete") {
					// Donate
					$.ajax({
						url,
						method: 'post',
						data: {
							...data,
							captcha_token: window.meta_object.captcha_token,
							nonce: window.meta_object.nonce,
							action: 'donate',
						},
						dataType: 'json'
					}).always(() => {
						formMessages().reloadCaptcha();
					}).done((result) => {
						if (result.success) {
							if (result.successUrl) {
								window.location.replace(result.successUrl);
								loadingLayer.hideLoading();
								return;
							}
						}
					}).fail((err) => {
						loadingLayer.hideLoading();
						console.log(err);
					});
				} else if (result == "Error") {
					formMessages($form, {
						success: false,
						message: 'Please check your credit/debit card information and try again.',
					}).run();
				}
			});
		});
	},
	finalize() {

	},
};



// WEBPACK FOOTER //
// ./scripts/routes/blocks/donate.js